// src/pages/Logout.tsx

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import { removeAuthToken } from '../utils/auth';
import { useAuth } from '../context/AuthContext'; // Import useAuth

const Logout: React.FC = () => {
    const navigate = useNavigate();
    const { logout } = useAuth(); // Get the logout function from AuthContext

    useEffect(() => {
        // // Clear user data from local storage
        // // localStorage.removeItem('token');
        // removeAuthToken();

        // localStorage.removeItem('user');
        // localStorage.removeItem('rolesPermissions');
        // localStorage.removeItem('cart'); // Clear the cart from localStorage 250318
        // localStorage.removeItem('settings'); // Clear the settings from localStorage 250318

        // // Redirect to login or home page
        // navigate('/login'); // Change this to your desired route

    // }, [navigate]);
        logout(); // Call the logout function from AuthContext
        // The logout function in AuthContext now handles clearing localStorage,
        // setting auth state, and reloading the window.
        // Navigation to '/login' will happen implicitly after reload if routes are protected,
        // or you can add navigate('/login') in AuthContext's logout if preferred, before the reload.
    }, [logout, navigate]);

    
    return (
        <div>
            <p>Logging out...</p>
        </div>
    );
};

export default Logout;